// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_math from "../../../../node_modules/rescript/lib/es6/js_math.js";
import * as Rollbar from "../../../../node_modules/rescript-rollbar/lib/es6_global/src/Rollbar.bs.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as Caml_js_exceptions from "../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as RollbarInstance$Showside from "./RollbarInstance.bs.js";
function WrapInIframe(Props) {
  var style = Props.style;
  var children = Props.children;
  var randId = React.useRef(String(Js_math.random_int(1000, 9999))).current;
  var match = React.useState(function () {});
  var setHeight = match[1];
  var height = match[0];
  React.useEffect(function () {
    var onResize = function ($$event) {
      var _type = $$event.data.type;
      var height = $$event.data.height;
      var error = $$event.data.error;
      if (_type !== undefined) {
        if (_type === "maker_nav_iframe_resize_" + randId) {
          return Curry._1(setHeight, function (previous) {
            return Belt_Option.orElse(height, previous);
          });
        } else if (_type === "maker_nav_iframe_error_" + randId) {
          Belt_Option.map(error, function (error) {
            return RollbarInstance$Showside.jsError1(Rollbar.$$Error.fromRescriptWithNewMessage(Caml_js_exceptions.internalToOCamlException(error), "Error raised in iframe embed: " + error.message));
          });
          return;
        } else {
          return;
        }
      }
    };
    window.addEventListener("message", onResize);
    return function (param) {
      window.removeEventListener("message", onResize);
    };
  }, []);
  var style$1 = React.useMemo(function () {
    var styleWithHeight = height !== undefined ? {
      height: CSS$Showside.intToPx(height)
    } : {};
    var style$2 = style !== undefined ? Caml_option.valFromOption(style) : {};
    return Object.assign({}, style$2, styleWithHeight);
  }, [style, height]);
  var srcDoc = "<html style=\"overflow:hidden\">\n  <head>\n    <style>body{margin:0}</style>\n    <script>window.onerror = (message, file, line, column, errorObj) => {\n      window.parent.postMessage({\n        type: 'maker_nav_iframe_error_" + randId + "',\n        error: {\n          message,\n          file,\n          line,\n          column,\n          errorObj\n        },\n        '*'\n      })\n    }</script>\n    <script>document.addEventListener('click', e => (e.target.closest('a')?.href && (e.preventDefault(), window.top.location.href = e.target.closest('a').href)));</script>\n    <script>window.addEventListener('message', function(event) { if (window !== window.parent) { window.parent.postMessage(event.data, '*') }})</script>\n    <script>(function() {\n      const sendResize = () => {\n        const height = document.documentElement.offsetHeight || document.body.offsetHeight;\n        if (!height) {\n          return;\n        }\n\n        window.parent.postMessage(\n          {\n            type: 'maker_nav_iframe_resize_" + randId + "',\n            height\n          },\n          '*'\n        );\n      };\n\n      window.addEventListener('load', () => {\n        new ResizeObserver(sendResize).observe(document.body);\n        sendResize();\n      });\n      window.addEventListener('DOMContentLoaded', sendResize);\n    })();</script>\n  </head>\n  <body>" + children + "</body>\n</html>";
  return React.createElement("iframe", {
    style: style$1,
    srcDoc: srcDoc
  });
}
WrapInIframe.displayName = "WrapInIframe";
var make = WrapInIframe;
export { make };
/* react Not a pure module */